export default __webpack_public_path__ + "static/media/logoAe.c84e8c36.png";